import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import classnames from 'classnames';

import Hyperlink from '../../common/Hyperlink';

const DefaultHeaderLink = ({ to, children, pathWithoutBasename, onClick, openInNewTab }) => {
  const className = classnames('defaultHeaderLink', {
    active: (to === '/' ? to : to.replace('/', '')) === pathWithoutBasename,
  });

  return (
    <Hyperlink to={to} className={className} onClick={onClick} openInNewTab={openInNewTab}>
      {children}
    </Hyperlink>
  );
};

DefaultHeaderLink.propTypes = {
  pathWithoutBasename: PropTypes.string,
  children: PropTypes.node,
  to: PropTypes.string,
  onClick: PropTypes.func,
  openInNewTab: PropTypes.bool,
};

export default withRouteData(DefaultHeaderLink);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/DefaultHeaderLink.js